// var tableToExcel = (function() {
//     var uri = 'data:application/vnd.ms-excel;base64,'
//       , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style> .celdaFueradeRango{color: white;background-color: red;} </style></head><body><table>{table}</table></body></html>'
//       , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
//       , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
//     return function(table, name) {
//       if (!table.nodeType) table = document.getElementById(table)
//       var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
//       window.location.href = uri + base64(format(template, ctx))
//     }
//   })()
   
//   export default {
//       tableToExcel
//   }



var tableToExcel = (function (table,name) {
  var encabezado = '<html><head><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style> table, td {border:thin solid  black} table {border-collapse:collapse}</style></head><body><table>';

  var dataTable =  document.getElementById(table).innerHTML

  var piePagina = "</table></body></html>";
  var tabla = encabezado + dataTable + piePagina;
  var myBlob =  new Blob( [tabla] , {type:'text/html'});
  var url = window.URL.createObjectURL(myBlob);
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.href = url;
  a.download = name +".xls";
  a.click();
  
  setTimeout(function() {window.URL.revokeObjectURL(url);},0);
});
 


 
 

 
 

// export default { exportToExcel };
function formatDate(date) {
  if (!date) return '';

if (date instanceof Date) {
  date = date.toISOString();
}
if (typeof date === 'string') {
  const parts = date.split('T')[0].split('-');
  if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
}

return date; 
}
////

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

async function  exportToExcel(title,tableInfo) {

  var NameColumnImg='img'
  console.log("------",tableInfo )
  let dataTable=tableInfo
  title=title + '.xlsx'
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');
  dataTable.forEach(element => {
    delete element['idDocument']
    delete element['sendEmail']
  });
  // Agrega encabezados
  const headers = Object.keys(dataTable[0]);
  worksheet.columns = headers.map(headerInfo => ({ header :headerInfo.toUpperCase() , key: headerInfo, width: 30 }));
  worksheet.font = { family: 4, size: 10, bold: true };
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
});
  for (let i = 0; i < dataTable.length; i++) {
      const item = dataTable[i];
      let imgSource=item[NameColumnImg]
      let imgSource1=item[NameColumnImg+"_1"]
      let imgSource2=item[NameColumnImg+"_2"]
      let imgSource3=item[NameColumnImg+"_3"]
      let imgSource4=item[NameColumnImg+"_4"]
      let imgSource5=item[NameColumnImg+"_5"]
      item.dateFinish= formatDate(item.dateFinish);
      item.fecha= formatDate(item.fecha);
      item.data= formatDate(item.data); 
      const row = worksheet.addRow(item);



      // Agrega la imagen si existe en la columna 'Img'
      if (imgSource) {
          row.height = 100; 
      const imageId = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId, {
          tl: { col: headers.indexOf(NameColumnImg), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg) + 1);
      cell.value = ''; 
      }


      if (imgSource1) {
        row.height = 100; 
      const imageId1 = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource1.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId1, {
          tl: { col: headers.indexOf(NameColumnImg+"_1"), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg+"_1") + 1);
      cell.value = ''; 
      }
      

      if (imgSource2) {
        row.height = 100; 
      const imageId2 = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource2.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId2, {
          tl: { col: headers.indexOf(NameColumnImg+"_2"), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg+"_2") + 1);
      cell.value = ''; 
      }

      if (imgSource3) {
        row.height = 100; 
      const imageId3 = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource3.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId3, {
          tl: { col: headers.indexOf(NameColumnImg+"_3"), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg+"_3") + 1);
      cell.value = ''; 
      }

      if (imgSource4) {
        row.height = 100; 
      const imageId4 = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource4.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId4, {
          tl: { col: headers.indexOf(NameColumnImg+"_4"), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg+"_4") + 1);
      cell.value = ''; 
      }

      if (imgSource5) {
        row.height = 100; 
      const imageId5 = workbook.addImage({
          base64: 'data:image/png;base64,'+imgSource5.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,',''),
          extension: 'png',
      });
      worksheet.addImage(imageId5, {
          tl: { col: headers.indexOf(NameColumnImg+"_5"), row: row.number - 1 },
          ext: { width: 120, height: 120 }
      });
      const cell = worksheet.getCell(row.number, headers.indexOf(NameColumnImg+"_5") + 1);
      cell.value = ''; 
      }








  } 
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell) => {
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
    });
});
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), title);
  }

  export default {

    exportToExcel,
    tableToExcel
  }